import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { PRICE, FULL_PRICE } from '../data/content';
import { CtaButton } from './ui/CtaButton';
import { Reveal } from './ui/Reveal';
export function FinalCta() {
  return <section className="grain bg-ink px-4 py-14 sm:px-5 sm:py-24" data-id="element-61" data-mp="19fqlxrsvdjd5">
      <Reveal data-id="element-62" data-mp="15cu9yjxu4li6">
        <div className="mx-auto max-w-3xl text-center" data-id="element-63" data-mp="15car910d1t33">
          <h2 className="display mx-auto max-w-[24ch] text-[1.8rem] text-cream sm:text-[3.1rem]" data-id="element-64" data-mp="1jd52dresm85g">
            Trasforma un pomeriggio di schermi in{' '}
            <span className="text-sun" data-id="element-65" data-mp="1ed8yrta0ciqf">un pomeriggio di invenzioni.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] font-semibold leading-relaxed text-cream/60 sm:mt-5 sm:text-lg" data-id="element-66" data-mp="1t1wqtpknaabm">
            Apri il Laboratorio, scegliete una missione e mettete in moto il
            genio di tuo figlio.
          </p>

          <div className="mt-8 flex flex-col items-center sm:mt-10" data-id="element-67" data-mp="2219zig0y2uva">
            <p className="text-[10px] font-black uppercase tracking-[0.16em] text-cream/45" data-id="element-68" data-mp="1x64j1wqba8el">
              <span className="line-through" data-id="element-69" data-mp="n75mxtwsqh46">{FULL_PRICE}</span> · offerta di
              lancio
            </p>
            <p className="display mt-2 text-[3rem] leading-none text-sun sm:text-[4.5rem]" data-id="element-70" data-mp="s4xolfn8thlk">
              {PRICE}
            </p>

            <CtaButton className="mt-6 w-full whitespace-nowrap sm:mt-7 sm:max-w-md" data-id="element-71" data-mp="122ve06gu9kfr">
              Voglio il Laboratorio
            </CtaButton>

            <ul className="mt-6 flex flex-col items-center gap-2.5 text-[10px] font-black uppercase tracking-[0.12em] text-cream/50 sm:mt-7 sm:flex-row sm:gap-x-6" data-id="element-72" data-mp="163p2p223v39p">
              <li className="flex items-center gap-2" data-id="element-73" data-mp="1ftqdwt9d0r77">
                <ZapIcon className="h-4 w-4 text-sun" aria-hidden="true" data-id="element-74" data-mp="1fv1q9hgvf79x" />
                Accesso in meno di un minuto
              </li>
              <li className="flex items-center gap-2" data-id="element-75" data-mp="1psppajlif0xw">
                <ShieldCheckIcon className="h-4 w-4 text-sun" aria-hidden="true" data-id="element-76" data-mp="1puaia4s6ebtn" />
                Garanzia di 7 giorni
              </li>
            </ul>
          </div>
        </div>
      </Reveal>
    </section>;
}